import { getThumbnail, createSrcSet } from './utils'
import type { File, Thumbnail } from './types'
import type { ObjectFit } from 'components/Image'

type useResponsiveImageProps = {
  files?: File[]
  name: string
}

const defaultImgExport = {
  src: '',
  alt: '',
  srcSet: undefined,
  objectFit: 'scale-down' as ObjectFit,
  width: '100%',
  height: '100%',
}

export default function useResponsiveImage({
  name,
  files,
}: useResponsiveImageProps) {
  if (!files?.length) {
    return defaultImgExport
  }

  return {
    ...defaultImgExport,
    src: getThumbnail(files[0].thumbnails as Thumbnail[]),
    alt: name,
    srcSet: createSrcSet(files) || undefined,
  }
}
